import React from 'react';

function withDataHandler(attrs) {
  return function componentHandler(Component) {
    return class Wrapper extends React.Component {
      state = attrs.initialState || {};
      
        update = (field, item) => {
          this.setState(p => {
            if(item && typeof item === 'object') {

             return {
                [field]: {
                  ...p[field],
                  ...item
                }
              };
            } else {
              return {
                [field]: item
              };
            }
          })
        }

        updateElement = (entity, content) => {
          const [name, id] = entity.split('.');
          this.setState(p => ({
            [name]: {
              ...p[name],
              elements: {
                ...p[name].elements,
                [id]: {
                  ...p[name].elements[id],
                  ...content
                }
              }
            }
          }));
        }

        updateMany = (fieldsArr) => {
          this.setState(p => {
            const newState = {
              ...p
            };
            fieldsArr.forEach(tuple => {
              if(tuple[1] && typeof tuple[1] === 'object') {
                newState[tuple[0]] = {
                  ...newState[tuple[0]],
                  ...tuple[1]
                }
              } else {
                newState[tuple[0]] = tuple[1];
              }    
            });
            return newState;
          });
        }

      render() {
        return (
          <Component {...this.props} update={this.update} updateMany={this.updateMany} updateElement={this.updateElement} data={this.state} />
        );
      }
    }
  }
}

export default withDataHandler;


// WEBPACK FOOTER //
// ./src/components/HOC/withDataHandler.jsx